import gzIcon from 'gazelle/src/components/icon/icon.module';
import gzSpinner from 'gazelle/src/components/spinner/spinner.module';
import gzPageHeader from 'gazelle/src/components/page-header/page-header.module';

export default angular.module('gazelle.bundles.widgets', [
  gzIcon,
  gzSpinner,
  gzPageHeader
]).name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/bundles/widgets.module.js